import clsx from 'clsx'
import { motion } from 'motion/react'
import { type PropsWithChildren } from 'react'

type Props = {
  maxWidth?: 'sm' | 'md' | 'lg'
  verticallyCentered?: boolean
}

export default function PageContainer ({
  maxWidth = 'sm',
  verticallyCentered,
  children,
}: PropsWithChildren<Props>) {
  return (
    <div className={clsx('flex flex-col flex-1 items-center p-8 xs:p-10', {
      'justify-center': verticallyCentered,
    })}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={clsx('flex flex-col gap-10 w-full', {
          'max-w-[30rem]': maxWidth === 'sm',
          'max-w-[45rem]': maxWidth === 'md',
          'max-w-[55rem]': maxWidth === 'lg',
        })}
      >
        {children}
      </motion.div>
    </div>
  )
}
